import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { ImageElement } from "components";

import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import { BROKER_ENDPOINT } from "apiEndpoints";
import socketEventManager from "socket/socketEvents";

const ModelGallery = () => {
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    activeOption: {
      index: 0,
      imageUrl: "",
    },
  });
  const navigate = useNavigate();
  const location = useLocation();

  const getCategoryDetails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });
      setState({
        ...state,
        isLoading: false,
        lists: response?.data?.data ?? [],
        activeOption: {
          index: 0,
          imageUrl: response?.data?.data?.[0]?.image_name,
        },
      });
    } catch (error) {
      setState({
        ...state,
        isLoading: false,
      });
    }
  };

  const handleStateChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      ...(typeof key === "string" ? { [key]: value } : key),
    }));
  };

  const handleChangeOption = (index, imageUrl) => {
    handleStateChange("activeOption", { index, imageUrl });
  };
  const handleSocketCommand = (item) => {    
    
    const object = {
      hardware_id: item?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      type : "gallery_image",
      image_id : item?.id,
      image_url : item?.image_name,
    }    
    socketEventManager.sendCommand(item?.hardware_id, object);
  }

  useEffect(() => {
    getCategoryDetails();
  }, []);

  return (
    <div className="modelGallery">
      <Container fluid className="p-0">
        <Row className="gx-0">
          <Col md={6}>
            {state.isLoading ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner />
              </div>
            ) : !state.isLoading && state.activeOption.imageUrl ? (
              <div className="modelGallery_left commonLeftImg">
                <div className="boxImage">
                  <ImageElement
                    imageFor="user"
                    previewSource={state.activeOption.imageUrl}
                    className="w-100"
                    alt="modal-gallery"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center vh-100">
                No data found
              </div>
            )}
          </Col>
          <Col md={6}>
            <div className="modelGallery_right d-flex flex-column justify-content-between align-items-center h-100vh">
              <div className="innerSwitch w-100">
                <header className="header w-100 d-flex align-items-center position-relative">
                  <div className="header_title mx-auto">
                    <h1 className="mb-0">Amenities Model</h1>
                  </div>
                  <Link className="header_logo" to={userRouteMap.LANDING.path}>
                    <ImageElement
                      imageFor="user"
                      source="logo.svg"
                      className="img-fluid"
                    />
                  </Link>
                </header>
                {/* <div className="customSwitch d-flex align-items-center w-100 justify-content-center">
                  <label className="switch">
                    <input type="checkbox" defaultChecked />
                    <span className="slider" />
                  </label>
                  <span className="switchLabel">LIGHTS</span>
                </div> */}
              </div>
              {state.isLoading ? (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  <Spinner />
                </div>
              ) : !state.isLoading && state.lists?.length > 0 ? (
                <div className="multiList text-center innerScroll multiList-list multiList-active">
                  <h2 className="text-uppercase innerHead">
                    {state?.lists?.[0]?.category_id?.name}
                  </h2>
                  <ListGroup>
                    {state?.lists?.map((item, index) => (
                      <ListGroup.Item className="multiList_item" key={index}>
                        <Link
                          className={`multiList_item_tab ${
                            state?.activeOption?.index === index
                              ? "active-heading"
                              : ""
                          }`}
                          onClick={() =>{
                            handleChangeOption(index, item?.image_name);
                            handleSocketCommand(item);
                          }}
                        >
                          {item.media?.media_name?.split(".")?.[0]}
                        </Link>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  No data found
                </div>
              )}

              <Link
                className="commonBack text-uppercase d-block h-auto"
                onClick={() => navigate(-1)}
              >
                <em className="icon-back" />
                <span className="d-block">Back</span>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ModelGallery;
